import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Popconfirm,
  message,
  Modal,
  Tooltip,
} from "antd";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { API_DELETE_STORE } from "api/store-managemnt"; // Import your API functions
import EditStore from "views/admin/storeManagement/EditStore";
import ViewStore from "views/admin/storeManagement/ViewStore/ViewStore";
import { API_LIST_MAIN_LAUNDRY } from "api/main-laundry-management";
import { API_DELETE_MAIN_LAUNDRY } from "api/main-laundry-management";
import EditLaundry from "views/admin/mainlaundryManagement/EditLaundry";
import ViewLaundry from "views/admin/mainlaundryManagement/ViewLaundry/ViewLaundry";
import { API_LIST_ROLE } from "api/role-management";
import { API_DELETE_ROLE } from "api/role-management";
import EditRole from "views/admin/roleManagement/EditRole";
import ViewRole from "views/admin/roleManagement/ViewRole/ViewRole";
import { API_LIST_CATAGORY } from "api/catagory-managemnt";
import { API_DELETE_CATAGORY } from "api/catagory-managemnt";
import EditCatagory from "views/admin/catagorymanagemnt/EditCatagory";
import ViewCatagory from "views/admin/catagorymanagemnt/ViewCatagory/ViewCatagory";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
const { Column } = Table;
const { TextArea } = Input;
const CatagoryTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 }); // Initial pagination settings
  const [searchName, setSearchName] = useState("");
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const [viewModalVisible, setViewModalVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
      };
      const newData = await API_LIST_CATAGORY(params);
      console.log("provider", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.total_categories }); // Assuming API response contains total count
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.current, pagination.pageSize, searchName]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleSearch = (value) => {
    setSearchName(value);
  };

  const handleEdit = (record) => {
    setSelectedStore(record);
    setEditModalVisible(true);
    setDeleteId(record._id);
    navigate(`/admin/catagory/edit/${record._id}`, {
      state: { data: record },
    });
  };

  const handleView = (record) => {
    setSelectedStore(record);
    setViewModalVisible(true);

    navigate(`/admin/catagory/${record._id}`, {
      state: { data: record },
    });
  };

  const handleDelete = async (id) => {
    try {
      let q = await API_DELETE_CATAGORY(id);
      message.success(q?.message);
      setEditModalVisible(false);
      fetchData(); // Refresh data after delete
    } catch (error) {
      console.error("Error deleting store:", error);
      message.error("Failed to delete catagory");
    }
  };

  const handleEditModalOk = () => {
    // Implement edit store logic here
    console.log("Editing store:", selectedStore);
    setEditModalVisible(false);
  };

  const handleViewModalOk = () => {
    // Implement view store logic here
    console.log("Viewing store:", selectedStore);
    setViewModalVisible(false);
  };

  const handleModalCancel = () => {
    setEditModalVisible(false);
    setViewModalVisible(false);
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  return (
    <div>
      <div className=" mb-4 flex justify-between">
        <Input
          className="border-none"
          placeholder={t("Search by name")}
          prefix={<SearchOutlined />}
          allowClear
          onChange={(e) => handleSearch(e.target.value)}
          style={{ width: 200 }}
        />

        <Link
          to={"/admin/catagory/create-catagory"}
          className="linear p-[4px 11px] flex w-full max-w-[9rem] cursor-pointer items-center justify-center rounded-xl bg-brand-500 py-2 text-center text-base font-medium text-white transition duration-200 hover:bg-white hover:text-brand-500 dark:bg-brand-400 dark:text-white  dark:active:bg-brand-200"
        >
          + {t("Create Catagory")}
        </Link>
      </div>
      <Table
        dataSource={data?.categories}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id} // Assuming each record has a unique id
        rowClassName={getRowClassName} // Apply alternating row colors
      >

        <Column
          title={t("Catagory Name")}
          dataIndex="title"
          key="title"
          width="9rem"
        />

        <Column
          title={t("Catagory Description")}
          dataIndex="description"
          key="description "
          width="9rem"
          render={(text) => (
            <Tooltip title={text}>
              {text.length > 20 ? `${text.substring(0, 20)}...` : text}
            </Tooltip>
          )}
        />

        <Column
          title={t("Actions")}
          key="actions"
          width="9rem"
          render={(text, record) => (
            <div>
              <Button
                type="primary"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              ></Button>
              <Popconfirm
                title="Are you sure to delete this Catagory?"
                onConfirm={() => {
                  if (record?.item_count > 0) {
                    setEditModalVisible(true);
                    setDeleteId(record?._id);
                  } else {
                    handleDelete(record?._id);
                  }
                }}
                okText="Yes"
                cancelText="No"
              >
                <Button
                  type="danger"
                  icon={<DeleteOutlined />}
                  style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                ></Button>{" "}
              </Popconfirm>
              <Button
                type="default"
                icon={<EyeOutlined />}
                onClick={() => handleView(record)}
                style={{ marginLeft: "5px" }}
              ></Button>
            </div>
          )}
        />
      </Table>

      {/* Edit Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("Edit Catagory")}
        visible={editModalVisible}
        onOk={handleEditModalOk}
        onCancel={handleModalCancel}
        centered
        // style={{ minWidth: "65rem" }}
      >
        Are you sure want to delete this catagory because by deleting this
        catagory your item related to this catagory will be deleted
        <div className="flex">
          <Button
            className="btn-gradient   mx-auto mt-4  flex w-40 p-5 text-[white]"
            onClick={() => handleDelete(deleteId)}
          >
            Yess
          </Button>

          <Button
            className="btn-gradient   mx-auto mt-4  flex w-40 p-5 text-[white]"
            onClick={() => {
              setEditModalVisible(false);
            }}
          >
            No
          </Button>
        </div>
        {/* <EditCatagory data={selectedStore} /> */}
      </Modal>

      {/* View Store Modal */}
      <Modal
        key={selectedStore?._id}
        // title={t("View Catagory")}
        visible={viewModalVisible}
        onOk={handleViewModalOk}
        onCancel={handleModalCancel}
        style={{ minWidth: "60rem" }}
      >
        <ViewCatagory data={selectedStore} />
      </Modal>
    </div>
  );
};

export default CatagoryTable;
